//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.isOpen = newVal
    },
    isOpen(newVal) {
      this.$emit('input', newVal)
    },
  },
}
